import { FunctionComponent } from 'react'

import { ArrowSquare, baseColors } from '@fairhq/common'

export const ArrowSquarePurple: FunctionComponent = () => (
  <ArrowSquare outline={baseColors.purple} stroke={baseColors.purple500} />
)
